import React from "react";
import { Grid } from "@material-ui/core";
import {
  InputOptionMaster,
  InputTextMaster,
  MasterButton,
} from "App/Component/ui";
import { useSelectOption } from "App/hooks";
import { RESET_STATE_FILTER_TEMPLATE, urlGetUnit } from "./helpers";
import { TYPE_INSTANCE4 } from "App/constants";
import { defaultToastError, isNull } from "App/utils/helpers";

export default function FormFilterTemplate({
  formFilter,
  setFormFilter,
  setNewData,
  onlyUnit = false,
}) {
  const unit = useSelectOption(true, urlGetUnit, TYPE_INSTANCE4, "id", "name");
  const handleChange = (text) => (e) => {
    setFormFilter({
      ...formFilter,
      [text]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    if (onlyUnit) {
      if (isNull(formFilter.unit_id)) {
        e.preventDefault();
        defaultToastError("Pilih unit terlebih dahulu");
      } else {
        e.preventDefault();
        await setNewData();
      }
    } else {
      e.preventDefault();
      await setNewData();
    }
  };
  return (
    <div
      style={{
        padding: "1rem 1.2rem",
      }}>
      <p className='fw-600 mb-2 mt-1'>DAFTAR TEMPLATE</p>
      <form onSubmit={(e) => handleSubmit(e)}>
        <Grid container spacing={1}>
          <Grid item sm={3}>
            <InputTextMaster
              name='id'
              label='ID'
              id='id'
              autoFocus={true}
              value={formFilter.id}
              onChange={handleChange("id")}
              placeholder='ID Template'
            />
          </Grid>
          <Grid item sm={3}>
            <InputTextMaster
              name='nama'
              label='NAMA'
              id='nama'
              autoFocus={true}
              value={formFilter.nama}
              onChange={handleChange("nama")}
              placeholder='Nama Template'
            />
          </Grid>

          <Grid item sm={3}>
            <InputOptionMaster
              name='unit_id'
              label='UNIT'
              id='unit_id'
              withSearch={true}
              data={unit}
              value={formFilter.unit_id}
              labelValue={formFilter.unit_name}
              onChange={(e) => {
                if (isNull(e)) {
                  setFormFilter({
                    ...formFilter,
                    unit_id: null,
                    unit_name: "Pilih Unit",
                  });
                } else {
                  setFormFilter({
                    ...formFilter,
                    unit_id: e.value,
                    unit_name: e.label,
                  });
                }
              }}
            />
          </Grid>
        </Grid>

        <Grid
          container
          className='mt-1'
          direction='row'
          justifyContent='space-between'
          alignItems='center'>
          <MasterButton
            name={"RESET"}
            outline={true}
            color={"danger"}
            type={"button"}
            size={"md"}
            onClick={() => setFormFilter(RESET_STATE_FILTER_TEMPLATE)}
          />
          <MasterButton
            name={"CARI"}
            outline={true}
            color={"green"}
            type={"submit"}
            size={"md"}
          />
        </Grid>
      </form>
      <br />
    </div>
  );
}
